import React from 'react';

// DL.14 - Άλλο
const DL14 = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 15) {
      updateFormData({ phone: value });
    }
  };


  return (
    <div>
      <div className="alert alert-info" style={{ marginBottom: '20px' }}>
        <p style={{ margin: 0 }}>
          <strong>Οδηγία:</strong> Παρακαλούμε όπως υποβάλετε το αίτημά σας με σαφήνεια και όλα τα απαραίτητα στοιχεία για την ταχύτερη εξυπηρέτησή σας.
        </p>
      </div>


      <div className="form-group">
        <label htmlFor="requestDetails">
          Περιγραφή Αιτήματος <span className="required">*</span>
        </label>
        <textarea
          id="requestDetails"
          name="requestDetails"
          value={formData.requestDetails || ''}
          onChange={handleChange}
          placeholder="Περιγράψτε λεπτομερώς το αίτημά σας..."
          rows="8"
          required
          style={{ width: '100%' }}
        />
        <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
          Συμπεριλάβετε όλες τις απαραίτητες πληροφορίες (ημερομηνίες, κλινική, κλπ)
        </small>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            placeholder="example@email.com"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">
            Τηλ. Επικοινωνίας <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            placeholder="2101234567"
            inputMode="numeric"
            pattern="\d{10,15}"
            title="Εισάγετε μόνο αριθμούς (10-15 ψηφία)"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default DL14;








